// Ana sayfa "Son 1 Ay Memnuniyet Trendi" yığılmış çubuk grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.surveyTrend';

export const surveyTrendGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Son 1 Ay Memnuniyet Trendi nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, son 1 ay içinde haftalık olarak müşteri memnuniyet anketlerindeki cevapların dağılımını yüzde olarak gösterir. Her çubuk bir haftadır ve o haftadaki anket cevaplarının yüzdesel dağılımını üst üste gösterir. Çubuğun üzerine gelince oranları ve o haftanın toplam cevap sayısını görürsünüz.'),
  chart: {
    kind: 'stacked',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Olumlu (Yeşil)'), text: t(`${G}.l1.text`, 'Olumlu cevapların o haftadaki tüm cevaplara oranı.') },
      { color: '#9E9E9E', label: t(`${G}.l2.label`, 'Nötr (Gri)'), text: t(`${G}.l2.text`, 'Nötr cevapların o haftadaki tüm cevaplara oranı.') },
      { color: '#F44336', label: t(`${G}.l3.label`, 'Olumsuz (Kırmızı)'), text: t(`${G}.l3.text`, 'Olumsuz cevapların o haftadaki tüm cevaplara oranı.') },
    ],
    note: t(`${G}.note`, 'Bu trend grafiği sayesinde müşteri memnuniyetinin zaman içindeki değişimini takip edebilir ve aldığınız aksiyonların sonuçlarını gözlemleyebilirsiniz.'),
  },
});
